import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Horse_show_entry_with_types } from '../models/horse_show_entry_with_types';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class HorseShowEntryWithTypesService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Horse_show_entry_with_types> {
	    return this.getWithRest('id/' + id);
	}

	private getWithRest(rest_fragment: string): Promise<Horse_show_entry_with_types> {
	    return new Promise((resolve, reject) => {
	      return this.http.get(AppSettings.API_ENDPOINT + 'horse_show_entry_with_types_controller/' + rest_fragment).subscribe((response:any) => {
	        if(response.type == 'horse_show_entry_with_types' && response.data){
	          resolve(response.data);
	        } else {
	          reject(response);
	        }

	      },
	        error_response => {
	              if(error_response instanceof HttpErrorResponse){
	                reject(error_response.error);
	              }
	              reject(error_response);
	        });
	    });
  }

}
